import * as ShoppingContextLoaded from '@ori-events/shopping-context-loaded';
import { HttpMethod } from '@ori/checkout-utils';
import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
export async function requestShoppingContextHandler() {
  const response = await fetch(RequestUrl.GetShoppingContext, getHttpRequestSettings(undefined, HttpMethod.Post));
  const data = convertToCamelCase(await response.json());
  const event = new CustomEvent(ShoppingContextLoaded.Name, {
    detail: data
  });
  window.dispatchEvent(event);
  return data;
}
//# sourceMappingURL=requestShoppingContextHandler.js.map